module.exports = __webpack_public_path__ + "img/jiaoyu.e8bb4f4f.svg";